import _classCallCheck from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/sarahhodges/Graphicacy/ia2030/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @module ol/interaction/PinchZoom
 */
import PointerInteraction, { centroid as centroidFromPointers } from './Pointer.js';
import { FALSE } from '../functions.js';
/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */

/**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */

var PinchZoom = /*#__PURE__*/function (_PointerInteraction) {
  _inherits(PinchZoom, _PointerInteraction);

  var _super = _createSuper(PinchZoom);

  /**
   * @param {Options} [options] Options.
   */
  function PinchZoom(options) {
    var _this;

    _classCallCheck(this, PinchZoom);

    options = options ? options : {};
    var pointerOptions =
    /** @type {import("./Pointer.js").Options} */
    options;

    if (!pointerOptions.stopDown) {
      pointerOptions.stopDown = FALSE;
    }

    _this = _super.call(this, pointerOptions);
    /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */

    _this.anchor_ = null;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 400;
    /**
     * @private
     * @type {number|undefined}
     */

    _this.lastDistance_ = undefined;
    /**
     * @private
     * @type {number}
     */

    _this.lastScaleDelta_ = 1;
    return _this;
  }
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   */


  _createClass(PinchZoom, [{
    key: "handleDragEvent",
    value: function handleDragEvent(mapBrowserEvent) {
      var scaleDelta = 1.0;
      var touch0 = this.targetPointers[0];
      var touch1 = this.targetPointers[1];
      var dx = touch0.clientX - touch1.clientX;
      var dy = touch0.clientY - touch1.clientY; // distance between touches

      var distance = Math.sqrt(dx * dx + dy * dy);

      if (this.lastDistance_ !== undefined) {
        scaleDelta = this.lastDistance_ / distance;
      }

      this.lastDistance_ = distance;
      var map = mapBrowserEvent.map;
      var view = map.getView();

      if (scaleDelta != 1.0) {
        this.lastScaleDelta_ = scaleDelta;
      } // scale anchor point.


      var viewportPosition = map.getViewport().getBoundingClientRect();
      var centroid = centroidFromPointers(this.targetPointers);
      centroid[0] -= viewportPosition.left;
      centroid[1] -= viewportPosition.top;
      this.anchor_ = map.getCoordinateFromPixelInternal(centroid); // scale, bypass the resolution constraint

      map.render();
      view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */

  }, {
    key: "handleUpEvent",
    value: function handleUpEvent(mapBrowserEvent) {
      if (this.targetPointers.length < 2) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
        view.endInteraction(this.duration_, direction);
        return false;
      } else {
        return true;
      }
    }
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */

  }, {
    key: "handleDownEvent",
    value: function handleDownEvent(mapBrowserEvent) {
      if (this.targetPointers.length >= 2) {
        var map = mapBrowserEvent.map;
        this.anchor_ = null;
        this.lastDistance_ = undefined;
        this.lastScaleDelta_ = 1;

        if (!this.handlingDownUpSequence) {
          map.getView().beginInteraction();
        }

        return true;
      } else {
        return false;
      }
    }
  }]);

  return PinchZoom;
}(PointerInteraction);

export default PinchZoom;